var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460.1 701.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.96,55.35c87.81,115.95,97.79,288.16,55.34,422.77-45.74,145.05-190.5,295.4-339,170.09-58.04-48.98-95.31-106.43-80.58-187.07,8.69-47.57,21.66-105.2,59.7-139.66,48.75-44.17,124.48-25.29,173.81,11.89,46.54,35.08,71.45,90.36,89.48,139.31,39.59-98.32,4.57-211.47-61.46-280-18.09-18.77-39.44-34.54-55.54-55.03-16.1-20.49-26.69-47.44-19.57-75.06C213.38-4.21,312.16-7.79,354.4,33.1c6.94,6.71,13.45,14.19,19.56,22.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.43,463.18c25.72-3.38,53.34,3.25,75.04,18.02,21.7,14.77,37.2,37.49,42.12,61.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.92,470.13c1.79-22.98,15.08-44.39,35.27-56.82"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.f4c1a309cab0348db1627cf1173ba4f5.svg";
export { ForwardRef as ReactComponent };